export default {
  getErrorDetails(state, getters) {
    return state.errorDetails
  }
}
